//todo это из нового кода, пзаюзать после полной миграции

/** @namespace Spatial */
NS("Spatial");

/**
 * @class
 */
Spatial.Security = Static(/** @lends Spatial.Security */{
    /**
     * Checks if current user has access to the item (takes into account ACL options of item).
     *
     * @param {Object} item Acl item
     * @param {string} key
     * @param {number|number[]} access
     * @param {number|number[]} [aclAction]
     *
     * @returns {boolean} Returns true if user has access to security key and
     *                    user is owner of item or item is public, or user satisfies ACL filters
     */
    checkItemAccess(item, key, access, aclAction) {
        var providers = context('providers');
        var provider = context('provider');

        providers = !_.isEmpty(providers) ?
                    _.map(providers, provider => _.parseInt(provider.id))
            : ( provider ? _.parseInt(provider.id) : [] );

        return check(key, access) && (
                isRoot() || _.includes(providers, _.parseInt(item.providerid)) ||
                aclAction === null
					//|| _.all(_.pick(item.acl), aclAction)
            );
    },
    /**
     * Verifies if user has access.
     *
     * @param {Object} item Acl item
     * @param {string} key
     * @param {number|number[]} access
     * @param {number|number[]} [aclAction]
     *
     * @returns {boolean} Returns true if user has access to security key and
     *                    user is owner of item or item is public, or user satisfies ACL filters
     *
     * @throws AccessDeniedError
     */
    verifyItemAccess(item, key, access, aclAction) {
        if (!this.checkItemAccess(item, key, access, aclAction)) {
            throw new AccessDeniedError('Access denied');
        }

        return true;
    },
    /**
     * Checks if current user has access to the item (takes into account ACL options of item).
     *      Calls alert on false.
     *
     * @param {Object} item Acl item
     * @param {string} key
     * @param {number|number[]} access
     * @param {number|number[]} [aclAction]
     *
     * @returns {boolean} Returns true if user has access to security key and
     *                    user is owner of item or item is public, or user satisfies ACL filters
     */
    checkItemAccessNotify(item, key, access, aclAction) {
        if (!this.checkItemAccess(item, key, access, aclAction)) {
            alert("Доступ запрещен");
            return false;
        }

        return true;
    }
});
